"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatComRequestParams = exports.getStreamPrivate = void 0;
// @ts-ignore
var whatwg_fetch_1 = require("whatwg-fetch");
var helper_1 = require("../../core/helper");
var LoadRequest = /** @class */ (function () {
    function LoadRequest() {
    }
    // private TIMEOUTS: number = 10000;
    LoadRequest.prototype.load = function (params, decrpytCallback, commonStream) {
        var _this = this;
        var url = params.url, timeout = params.timeout, method = params.method, body = params.body, setEncryptCb = params.setEncryptCb, reset = __rest(params, ["url", "timeout", "method", "body", "setEncryptCb"]);
        var fetch = this.getFetch();
        var controller = new AbortController();
        var tiemoutId = timeout && setTimeout(function () {
            controller.abort();
        }, timeout);
        var promise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var response, _requestParams, urlWithParams, _body, _a, _data, _headers, _response, contentType, reader_1, leftover_1, _b, record, done, error_1;
            var _this = this;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 12, 13, 14]);
                        _requestParams = __assign(__assign({}, reset), { method: method, credentials: 'include', signal: controller.signal });
                        urlWithParams = url;
                        if (method.toLocaleLowerCase() === 'get') {
                            if (body) {
                                _body = new URLSearchParams(body).toString();
                                urlWithParams = "".concat(url, "?").concat(_body.toString());
                            }
                        }
                        else {
                            _requestParams.body = body;
                        }
                        if (!setEncryptCb) return [3 /*break*/, 2];
                        return [4 /*yield*/, setEncryptCb(_requestParams.body)];
                    case 1:
                        _a = _d.sent(), _data = _a.content, _headers = __rest(_a, ["content"]);
                        _requestParams = __assign(__assign({}, _requestParams), { body: _data, headers: __assign(__assign({}, _requestParams.headers), _headers) });
                        _d.label = 2;
                    case 2: return [4 /*yield*/, fetch(urlWithParams, _requestParams)
                        // 清除超时
                    ];
                    case 3:
                        response = _d.sent();
                        // 清除超时
                        tiemoutId && clearTimeout(tiemoutId);
                        _response = response.clone();
                        contentType = response.headers.get('Content-Type') || '';
                        if (!contentType.includes('application/json')) return [3 /*break*/, 5];
                        return [4 /*yield*/, response.json()
                            // TODO : 这里判断是否需要处理错误
                        ];
                    case 4:
                        response = _d.sent();
                        // TODO : 这里判断是否需要处理错误
                        if (_response.status >= 400) {
                            reject(response);
                            return [2 /*return*/];
                        }
                        if (decrpytCallback) {
                            response = __assign(__assign({}, response), { data: JSON.parse(decrpytCallback(response.data)) });
                        }
                        return [3 /*break*/, 11];
                    case 5:
                        if (!contentType.includes('text/event-stream')) return [3 /*break*/, 9];
                        reader_1 = (_c = response.body) === null || _c === void 0 ? void 0 : _c.getReader();
                        if (!commonStream) return [3 /*break*/, 6];
                        response = {
                            reader: reader_1,
                            getStream: function () { return __awaiter(_this, void 0, void 0, function () {
                                var streamResponse, _a, respLeftOver, reset_1;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, getStreamPrivate({
                                                _reader: reader_1,
                                                decrypt: decrpytCallback,
                                                leftover: leftover_1
                                            })];
                                        case 1:
                                            _a = _b.sent(), respLeftOver = _a.leftover, reset_1 = __rest(_a, ["leftover"]);
                                            leftover_1 = respLeftOver;
                                            streamResponse = reset_1;
                                            _b.label = 2;
                                        case 2:
                                            if (leftover_1) return [3 /*break*/, 0];
                                            _b.label = 3;
                                        case 3: return [2 /*return*/, streamResponse];
                                    }
                                });
                            }); },
                        };
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, getStreamPrivate({
                            _reader: reader_1,
                            decrypt: decrpytCallback,
                        })];
                    case 7:
                        _b = _d.sent(), record = _b.record, done = _b.done;
                        if (record && record.length) {
                            response = record[0];
                        }
                        console.log('[ai sdk respone stream], done: ', done, response);
                        _d.label = 8;
                    case 8: return [3 /*break*/, 11];
                    case 9: return [4 /*yield*/, response.text()];
                    case 10:
                        response = _d.sent();
                        _d.label = 11;
                    case 11:
                        // TODO : 这里判断是否需要处理错误
                        if (_response.status >= 400) {
                            reject(response);
                        }
                        return [3 /*break*/, 14];
                    case 12:
                        error_1 = _d.sent();
                        console.error('[ai sdk LoadRequest.load error]*', error_1);
                        reject(error_1);
                        return [3 /*break*/, 14];
                    case 13:
                        tiemoutId && clearTimeout(tiemoutId);
                        return [7 /*endfinally*/];
                    case 14:
                        if (response) {
                            resolve(response);
                        }
                        else {
                            reject(null);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        return [
            promise,
            controller
        ];
    };
    LoadRequest.prototype.getFetch = function () {
        var fetch = window.fetch;
        if (!fetch) {
            // TODO: 这里待验证IE11兼容性，按需引入
            fetch = whatwg_fetch_1.fetch;
        }
        return fetch;
    };
    return LoadRequest;
}());
var getStreamPrivate = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _reader, decrypt, leftover, txt, decoder, _a, done, value, e_1, result, prefix_1, arr;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _reader = params._reader, decrypt = params.decrypt, leftover = params.leftover;
                txt = '';
                decoder = new TextDecoder();
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (_reader === null || _reader === void 0 ? void 0 : _reader.read())];
            case 2:
                _a = _b.sent(), done = _a.done, value = _a.value;
                if (done) {
                    return [2 /*return*/, {
                            done: true,
                            record: null,
                        }];
                }
                txt = decoder.decode(value);
                return [3 /*break*/, 4];
            case 3:
                e_1 = _b.sent();
                // 流式获取数据失败，返回错误给业务层处理
                throw e_1;
            case 4:
                if (leftover) {
                    txt = leftover + txt;
                    leftover = '';
                }
                // 没有以\n结尾的数据，说明数据还未接收完整
                if (!txt.endsWith('\n')) {
                    leftover = txt;
                    return [2 /*return*/, {
                            leftover: leftover,
                            done: false,
                            record: null,
                        }];
                }
                result = txt;
                if (txt) {
                    prefix_1 = 'data:';
                    try {
                        arr = txt.split('\n').filter(function (item) { return item.trim() !== '' && item.startsWith(prefix_1); });
                        arr = arr.map(function (item) {
                            var _resultItem = item.replace(prefix_1, '');
                            try {
                                _resultItem = JSON.parse(_resultItem);
                                if (decrypt) {
                                    return _resultItem.data ? __assign(__assign({}, _resultItem), { data: JSON.parse(decrypt(_resultItem.data)) }) : _resultItem;
                                }
                            }
                            catch (error) {
                                // 解析失败，不抛错，仅打印报错
                                console.log('[ai sdk encrypt error]', error);
                            }
                            return _resultItem;
                        });
                        result = arr;
                    }
                    catch (error) {
                        // 流式数据解析失败，不抛错
                        console.error('[get Stream error]', error);
                    }
                }
                return [2 /*return*/, {
                        done: false,
                        record: result,
                        leftover: leftover,
                    }];
        }
    });
}); };
exports.getStreamPrivate = getStreamPrivate;
var formatComRequestParams = function (params) {
    var _a;
    var url = params.url, data = params.data, _b = params.headers, headers = _b === void 0 ? {} : _b;
    // 处理私有化
    if (!url.startsWith('http')) {
        // 处理私有化，V2、V3
        if ((_a = window.__CONFIG__) === null || _a === void 0 ? void 0 : _a.pathPrefix) {
            params.url = window.location.origin + window.__CONFIG__.pathPrefix + params.url;
        }
        else if (url.startsWith('/office/v5/')) {
            params.url = (0, helper_1.getBaseUrlV5)() + params.url;
        }
    }
    // 处理data
    if (data) {
        params.body = params.data;
        delete params.data;
    }
    if (params.method.toLocaleLowerCase() !== 'get') {
        var isFormData = (params === null || params === void 0 ? void 0 : params.body) instanceof FormData;
        if (!isFormData) {
            params.body = JSON.stringify(params.body);
            // 处理headers
            params.headers = __assign(__assign({}, headers), { 'Content-Type': 'application/json' });
        }
    }
    return params;
};
exports.formatComRequestParams = formatComRequestParams;
exports.default = new LoadRequest();
